// extracted by mini-css-extract-plugin
module.exports = {"ds-loading":"Loading_ds-loading__sVpVs","loading":"Loading_loading__tXw3x"};